<template>
    <main id="vendors-list" class="site-main">
      <div :class="['loading-area', loadingVendors ? 'loading' : '']">
        <div :class="['loading-area__content', loadingVendors ? 'loading' : '']">
          <div class="grid-container">
            <div class="page-header grid-x grid-padding-x align-bottom">
              <div class="cell auto">
                <h1 class="page-header__title">Vendors</h1>

                <div class="grid-x">
                  <div class="cell auto">
                    <button @click="payAll" v-if="$store.state.shop.myshopify_domain === 'shop-boutique-collective.myshopify.com' || $store.state.shop.myshopify_domain === 'visceral-apps-staging.myshopify.com'">Pay All</button>
                    <button @click="updateVendors">Update Totals</button>
                    <p><i>The total Due is a cached value. If you feel this number is
                      out of sync with your commissions you can use this to
                      recalculate the total amount Due.</i></p>
                  </div>

                  <div class="cell auto text-right">
                    <span class="icon-action" @click="exportVendors">
                      <i class="far fa-arrow-to-bottom"></i> <span>Export</span>
                    </span>
                  </div>
                </div>
              </div>
            </div>

            <div class="panel no-padding">
              <searchBar placeholder="Search vendors" @sort="sort"
                         :value="searchValue" @search="search" :hiddenFilter="true"
                         :dateFilter="true" @dateFilter="dateFilter"
                         @hiddenFilter="hiddenFilter"></searchBar>

              <div :class="['loading-area', loading ? 'loading' : '']">
                <div :class="['loading-area__content', loading ? 'loading' : '']">
                  <pagination :prev="prev" :next="next" :start="start" :end="end"
                              :total="total" @paginate="paginate"></pagination>

                  <tableList :header="tableHeader" :data="tableData"
                             :loading="loading" @post="go" @sort="orderBy"
                             @callback="callback"></tableList>

                  <pagination :prev="prev" :next="next" :start="start" :end="end"
                              :total="total" @paginate="paginate"></pagination>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    <transition name="fade">
      <payout v-if="reviewPayout" :vendorId="reviewVendorId"
              :payoutTotal="payoutTotal" :vendorName="reviewVendorName"
              :vendorPayPalEmail="reviewVendorPayPalEmail"
              :lineItemIds="reviewLineItems"
              :payoutAll="true"
              @done="closePayout"></payout>
    </transition>
  </main>
</template>

<script>
import client from '@/mixins/client'
import paginationUtils from '@/mixins/paginationUtils'
import payout from '@/globals/payout'

export default {
  name: 'vendorsList',
  mixins: [client, paginationUtils],
  components: {
    payout
  },
  data: function () {
    return {
      loadingVendors: false,
      reviewPayout: false,
      reviewVendorId: null,
      reviewVendorName: '',
      reviewVendorPayPalEmail: '',
      reviewLineItems: [],
      payoutTotal: 0,
      params: {},
      limit: 100,
      action: '/vendors/commission-totals/',
      sort: 'name',
      tableHeader: {
        currentSort: 'name',
        data: [
          {
            label: 'Vendor',
            sort: 'name',
            class: 'full'
          },
          {
            label: 'Due',
            sort: 'commission_due',
            sortStart: '-'
          },
          {
            label: 'Paid',
            sort: 'commission_paid',
            sortStart: '-'
          },
          {
            label: 'Earned',
            sort: 'commission_earned',
            sortStart: '-'
          },
          // {
          //   label: 'Items Sold',
          //   class: 'show-for-large'
          //   // sort: 'sold',
          //   // sortStart: '-'
          // },
          {
            label: 'Products',
            class: 'show-for-large'
            // sort: 'product_count',
            // sortStart: '-'
          },
          {
            label: '',
            class: 'show-for-large'
          }
        ]
      },
      tableData: []
    }
  },
  methods: {
    exportVendors () {
      this.loading = true
      let endpoint = '/vendors/commission-totals/'
      let data = {
        ordering: 'name',
        page_size: 1000,
        format: 'csv'
      }

      if (this.params['start_date'] || this.params['end_date']) {
        endpoint = '/vendors/calculate-commission-totals/'

        if (this.params['start_date']) {
          data['start_date'] = this.params['start_date']
        }

        if (this.params['end_date']) {
          data['end_date'] = this.params['end_date']
        }
      }

      this.request('get', endpoint, data).then((response) => {
        let downloadLink = document.createElement('a')

        downloadLink.href = response
        downloadLink.target = '_blank'

        document.body.appendChild(downloadLink)
        downloadLink.click()
        document.body.removeChild(downloadLink)

        this.loading = false
      })
    },
    dateFilter (startDate, endDate) {
      if (startDate.length > 0) {
        this.params['start_date'] = startDate
      } else {
        delete this.params['start_date']
      }

      if (endDate.length > 0) {
        this.params['end_date'] = endDate
      } else {
        delete this.params['end_date']
      }

      if (this.params['start_date'] || this.params['end_date']) {
        this.action = '/vendors/calculate-commission-totals/'
      } else {
        this.action = '/vendors/commission-totals/'
      }

      this.getData()
    },
    go: function (id) {
      this.$router.push('/vendors/' + id)
    },
    buildTable () {
      for (let i = 0; i < this.data.length; i++) {
        let primary = '<div class="grid-x align-middle"><div class="cell shrink">' +
          '<div class="table-list__image table-list__image--rounded">'

        if (!this.isEmpty(this.data[i].image) && this.data[i].image !== undefined) {
          primary += '<div class="table-list__image__inner">'
          primary += '<img src="' + this.data[i].image + '">'
          primary += '</div>'
        } else {
          primary += '<div class="table-list__image__missing">' +
            '<i class="fas fa-user"></i></div>'
        }

        primary += '</div></div><div class="cell auto">' +
          '<span class="text-overflow">' + this.data[i].name

        if (this.data[i].contact_name !== null) {
          primary += '<br>' + this.data[i].contact_name
        }

        primary += '</span>'

        primary += '</div></div>'

        if (this.data[i].commission_totals !== undefined) {
          this.data[i].commission_due = this.data[i].commission_totals.due
          this.data[i].commission_paid = this.data[i].commission_totals.paid
          this.data[i].commission_earned = this.data[i].commission_totals.earned
          // this.data[i].amount_sold = this.data[i].commission_totals.amount_sold
          this.data[i].product_count = this.data[i].commission_totals.product_count
        }

        let row = {
          post: this.data[i].id,
          data: [
            {
              value: primary,
              class: 'full'
            },
            {
              value: this.formatMoney(this.data[i].commission_due) +
                '<span class="hide-for-medium"> due</span>',
              class: 'focus-text'
            },
            {
              value: this.formatMoney(this.data[i].commission_paid),
              class: 'show-for-medium'
            },
            {
              value: this.formatMoney(this.data[i].commission_earned),
              class: 'show-for-large'
            },
            // {
            //   value: this.data[i].amount_sold,
            //   class: 'show-for-large'
            // },
            {
              value: this.data[i].product_count,
              class: 'show-for-large'
            }
          ]
        }

        if (this.data[i].commission_due > 0) {
          row.data.push({
            value: '<button class="button--small">Pay Now</button>',
            class: 'show-for-large',
            callback: 'createPayout',
            callbackArgs: [this.data[i].id, this.data[i].name,
              this.data[i].commission_due, this.data[i].paypal_email]
          })
        } else {
          row.data.push({
            value: '<button class="button--small button--green disabled">Paid</button>',
            class: 'show-for-large'
          })
        }

        this.tableData.push(row)
      }
    },
    hiddenFilter (hidden) {
      this.params['hidden'] = hidden
      this.getData()
    },
    payAll () {
      this.loading = true
      let data = {
        'start_date': null,
        'end_date': null
      }
      if (this.params['start_date'] || this.params['end_date']) {
        if (this.params['start_date']) {
          data['start_date'] = this.params['start_date']
        }

        if (this.params['end_date']) {
          data['end_date'] = this.params['end_date']
        }
      }

      this.request('post', '/vendors/payouts/create-all/', data).then(response => {

      }).then(response => {
        this.loading = false
        this.getData()
      }).catch(error => {
        this.loading = false

        if (error) {
          this.errorMessage = error[0]
          this.error = true
        }
      })
    },
    createPayout (vendorId, vendorName, due, vendorPayPalEmail) {
      this.request('get', '/vendors/unpaid-commissions/' + vendorId + '/', {
        'date_start': this.params['start_date'],
        'date_end': this.params['end_date']
      }).then(response => {
        this.reviewPayout = true
        this.reviewVendorId = vendorId
        this.reviewVendorName = vendorName
        this.reviewLineItems = response.line_items
        this.selectedOrders = response.count
        this.payoutTotal = response.amount
        this.undoSelectAll = true
        this.reviewVendorPayPalEmail = vendorPayPalEmail
      })
    },
    closePayout () {
      this.reviewVendorId = null
      this.reviewVendorName = ''
      this.reviewVendorPayPalEmail = ''
      this.reviewPayout = false
      this.payoutTotal = 0

      this.getData()
    },
    updateVendors () {
      this.loadingVendors = true

      this.request('get', '/vendors/recalculate-totals/?shop_id=' + this.$store.state.shop.id + '&force=1&page=' + this.page).then(response => {
        this.loadingVendors = false
        this.getData()
      })
    }
  },
  mounted () {
    this.loading = true
    this.getData()
    // this.request('get', '/vendors/recalculate-totals/?shop_id=' + this.$store.state.shop.id + '&page=' + this.page).then(response => {
    //   this.getData()
    // })
  }
}
</script>

<style lang="scss">
  @import '../../styles/variables';
  @import '../../styles/mixins';

</style>



// WEBPACK FOOTER //
// src/pages/vendors/list.vue